module.exports = __webpack_public_path__ + "img/SwitchIt.2dacda40.svg";